import { render, staticRenderFns } from "./fbnumberbox.vue?vue&type=template&id=412663bd&"
import script from "./fbnumberbox.vue?vue&type=script&lang=js&"
export * from "./fbnumberbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports